export const CANVAS_SORT_OPTIONS = [
    { value: 'assignee', label: 'Assignee' },
    { value: 'star_level', label: 'Star' },
    { value: 'status', label: 'Status' },
    { value: 'created_at', label: 'Created' },
    { value: 'updated_at', label: 'Updated' },
];

export const DEFAULT_SORT_FIELDS = ['star_level', 'status', 'assignee', 'created_at', 'updated_at'];

export const VALID_SORT_FIELD_VALUES = CANVAS_SORT_OPTIONS.map(o => o.value);

export const SORT_FIELD_COUNT = CANVAS_SORT_OPTIONS.length;

export const DATE_SORT_FIELDS = ['created_at', 'updated_at'];

/** Returns the primary sort field when it is a date field, otherwise null. */
export function getPrimarySortDateField(sortFields) {
    const primary = sortFields?.[0];
    return DATE_SORT_FIELDS.includes(primary) ? primary : null;
}

/**
 * Ensure sortFields is exactly SORT_FIELD_COUNT valid, unique field names.
 * Invalid or duplicate values are removed and backfilled from defaults.
 */
export function sanitizeSortFields(fields) {
    const valid = [];
    for (const field of fields || []) {
        if (VALID_SORT_FIELD_VALUES.includes(field) && !valid.includes(field)) {
            valid.push(field);
        }
    }
    for (const defaultField of DEFAULT_SORT_FIELDS) {
        if (valid.length >= SORT_FIELD_COUNT) break;
        if (!valid.includes(defaultField)) {
            valid.push(defaultField);
        }
    }
    return valid.slice(0, SORT_FIELD_COUNT);
}
